import Vue from "vue";
import Router from "vue-router";
import Consent from "@/components/Pages/Consent";
import Settings from "@/components/Pages/Settings";
import Research from "@/components/Pages/Research";
import NotFound from "@/components/Pages/NotFound";
import Tutorial from "@/components/Pages/Tutorial";
import Branch from "@/components/Pages/Branch";
import Main from "@/components/Pages/Main";

Vue.use(Router);
Vue.use(require("vue-cookies"));

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Main",
      component: Main,
    },
    {
      path: "/tutorial",
      name: "Tutorial",
      component: Tutorial,
    },
    {
      path: "/branch",
      name: "Branch",
      component: Branch,
    },
    {
      path: "/consent",
      name: "Consent",
      component: Consent,
    },
    {
      path: "/setting",
      name: "Settings",
      component: Settings,
    },
    {
      path: "/research",
      name: "Research",
      component: Research,
    },
    {
      path: "*",
      name: "404",
      component: NotFound,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js